<!--
 * @Author: DY
 * @Date: 2020-06-21 18:58:13
 * @LastEditTime: 2020-06-21 21:06:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile\src\App.vue
-->
<template>
    <div id="wapper">
        <transition :name="transitionName">
            <keep-alive :include="keepAlive">
                <router-view class="child-view"></router-view>
            </keep-alive>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'app',
    data() {
        return {
            transitionName: '', // 初始过渡动画方向
        };
    },
    watch: {
        $route() {
            // 切换动画
            const isBack = this.$router.isBack; // 监听路由变化时的状态为前进还是后退
            if (isBack === 1) {
                this.transitionName = 'slide-left';
            } else if (isBack === 2) {
                this.transitionName = 'slide-right';
            }
            this.$router.isBack = 0;
        },
    },
    computed: {
        keepAlive() {
            return this.$store.getters.keepAlive;
        },
    },
};
</script>

<style lang="stylus">
html, body, #wapper
    height 100%
#wapper
    position relative
    width 100%
    height 100%
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    color #2c3e50
    .child-view
        position absolute
        width 100%
        height 100%
        transition all 0.2s ease
        will-change transform
        top 0
        backface-visibility hidden
        perspective 1000
    .slide-left-enter, .slide-right-leave-active
        opacity 0
        transform translate3d(-100%, 0, 0)
    .slide-left-leave-active, .slide-right-enter
        opacity 0
        transform translate3d(100%, 0, 0)
</style>
